/**
 * Created by Omar Alejandro Leonor Avalos on 2017-09-11.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as globalActions from '../../global.actions';

class Home extends Component {
    render() {
        const { showSuccessMessage } = this.props;
        return (
            <div
                className="container"
                style={{
                    display: 'flex',
                    alignSelf: 'center',
                    justifyContent: 'center'
                }}
            >
                <img
                    role="presentation"
                    src="images/logo-title-dark.png"
                    style={{ marginTop: '20rem' }}
                    onClick={() => {
                        //Example of how to use a general notification
                        showSuccessMessage('Bienvenido!');
                    }}
                />
            </div>
        );
    }
}

export default connect(() => ({}), { ...globalActions })(Home);



// WEBPACK FOOTER //
// ./containers/home/index.js